[
  {
    "inicio": "2026-07-26",
    "fim": "2026-08-01"
  }
]
